
import {defineComponent} from "vue";
import {CodeDescriptionRestDto, MultilingualProductPropertyRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {PRODUCT_PROPERTY_TYPE_CODES_ENUM} from "@/store/pharma-cpc-product-mgmt/middleware";
import {PropType} from "vue/dist/vue";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";

export default defineComponent({
  name: "CustomerProductPropertiesItem",
  emits: ['update:modelValue'],
  components: {InputTextEditor},
  props: {
    modelValue: {
      type: Object as PropType<MultilingualProductPropertyRestDto>,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localText: this.modelValue.value.nl
    }
  },
  watch: {
    modelValue: {
      handler(newValue: MultilingualProductPropertyRestDto) {
        this.localText = newValue.value.nl;
      },
      immediate: true,
    }
  },
  computed: {
    productPropertyType(): CodeDescriptionRestDto | undefined {
      return PRODUCT_PROPERTY_TYPE_CODES_ENUM
          .find((productPropertyType: CodeDescriptionRestDto) => productPropertyType.code === this.modelValue.property_type_code);
    },
  },
  methods: {
    emitNewValue(): void {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        value: {
          ...this.modelValue.value,
          nl: this.localText
        }
      });
    }
  }
});
